import React from 'react'
import { NavLink } from 'react-router'
import { LinearProgress, Table, TableBody, TableContainer, Typography } from '@mui/material'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import { normalizedWarrantName } from '@finance-lab/utils/shared'
import { CompanyEventRow } from './CompanyEventRow'
import WarrantApi from '../../../../api/WarrantApi'
import { WarrantEntity } from 'types/WarrantEntity'
import { IsinEntity } from '@finance-lab/utils/types'

async function addIsinToWarrant(warrant: { id: string; instrumentType: string }, isin: IsinEntity) {
    const warrantApi = new WarrantApi()

    if (isin.instrumentType !== 'warrant') return null

    if (!warrant || !isin) {
        console.error(`addIsinToWarrant: Missing ${warrant ? '' : 'issue'} ${isin ? '' : 'isin'}`)
        return null
    }

    const updatedWarrantIsin = await warrantApi.patchFields(warrant.id, { isinWarrant: isin.isin })

    return updatedWarrantIsin
}

export const CompanyWarrants = ({
    warrants,
    selectedIsin,
    setSelectedIsin,
    onArchiveIsin,
}: {
    selectedIsin: IsinEntity | null
    setSelectedIsin: (i: IsinEntity | null) => void
    onArchiveIsin: (isin: IsinEntity, archive?: boolean) => Promise<void>
    warrants: Array<
        Pick<
            WarrantEntity,
            'id' | 'subscriptionPeriods' | 'unlisted' | 'instrumentName' | 'companyName' | 'instrumentSymbol' | 'name'
        >
    > | null
}) => {
    if (!warrants) return <LinearProgress />
    if (warrants.length === 0) return <Typography variant='body1'>Inga teckningsoptioner hittades</Typography>

    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {warrants.map((warrant) => {
                        let dates = null
                        if (warrant.subscriptionPeriods?.length === 1) {
                            dates = `${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subStartDate)} - ${formatDateYYYYMMDD(warrant.subscriptionPeriods[0].subEndDate)}` // prettier-ignore
                        } else if (warrant.subscriptionPeriods?.length > 1) {
                            dates = 'Flera teckningsperioder'
                        }
                        return (
                            <CompanyEventRow
                                key={warrant.id}
                                event={warrant}
                                eventType='warrant'
                                selectedIsin={selectedIsin}
                                setSelectedIsin={setSelectedIsin}
                                addIsinToEntity={addIsinToWarrant}
                                onArchiveIsin={onArchiveIsin}
                            >
                                <NavLink to={`/admin/warrants/${warrant.id}`} target='_blank'>
                                    {normalizedWarrantName(warrant)}
                                    {!!warrant.unlisted && '(Onoterad)'}
                                </NavLink>
                                {dates && <i>{dates}</i>}
                            </CompanyEventRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
